/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { BooleanDlmBaseResponse } from '../models/boolean-dlm-base-response';
import { LoadCellTypeResponse } from '../models/load-cell-type-response';
import { LoadCellTypeResponseDlmBaseResponse } from '../models/load-cell-type-response-dlm-base-response';
import { LoadCellTypeResponseListDlmBaseResponse } from '../models/load-cell-type-response-list-dlm-base-response';

@Injectable({
  providedIn: 'root',
})
export class LoadCellTypeService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation apiLoadCellTypeLoadCellTypesGet
   */
  static readonly ApiLoadCellTypeLoadCellTypesGetPath = '/api/LoadCellType/loadCellTypes';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiLoadCellTypeLoadCellTypesGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiLoadCellTypeLoadCellTypesGet$Plain$Response(params?: {
    archived?: boolean;
  }): Observable<StrictHttpResponse<LoadCellTypeResponseListDlmBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, LoadCellTypeService.ApiLoadCellTypeLoadCellTypesGetPath, 'get');
    if (params) {
      rb.query('archived', params.archived, {});
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<LoadCellTypeResponseListDlmBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiLoadCellTypeLoadCellTypesGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiLoadCellTypeLoadCellTypesGet$Plain(params?: {
    archived?: boolean;
  }): Observable<LoadCellTypeResponseListDlmBaseResponse> {

    return this.apiLoadCellTypeLoadCellTypesGet$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<LoadCellTypeResponseListDlmBaseResponse>) => r.body as LoadCellTypeResponseListDlmBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiLoadCellTypeLoadCellTypesGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiLoadCellTypeLoadCellTypesGet$Json$Response(params?: {
    archived?: boolean;
  }): Observable<StrictHttpResponse<LoadCellTypeResponseListDlmBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, LoadCellTypeService.ApiLoadCellTypeLoadCellTypesGetPath, 'get');
    if (params) {
      rb.query('archived', params.archived, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<LoadCellTypeResponseListDlmBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiLoadCellTypeLoadCellTypesGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiLoadCellTypeLoadCellTypesGet$Json(params?: {
    archived?: boolean;
  }): Observable<LoadCellTypeResponseListDlmBaseResponse> {

    return this.apiLoadCellTypeLoadCellTypesGet$Json$Response(params).pipe(
      map((r: StrictHttpResponse<LoadCellTypeResponseListDlmBaseResponse>) => r.body as LoadCellTypeResponseListDlmBaseResponse)
    );
  }

  /**
   * Path part for operation apiLoadCellTypeLoadCellTypePost
   */
  static readonly ApiLoadCellTypeLoadCellTypePostPath = '/api/LoadCellType/loadCellType';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiLoadCellTypeLoadCellTypePost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiLoadCellTypeLoadCellTypePost$Plain$Response(params?: {
    body?: LoadCellTypeResponse
  }): Observable<StrictHttpResponse<LoadCellTypeResponseDlmBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, LoadCellTypeService.ApiLoadCellTypeLoadCellTypePostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<LoadCellTypeResponseDlmBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiLoadCellTypeLoadCellTypePost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiLoadCellTypeLoadCellTypePost$Plain(params?: {
    body?: LoadCellTypeResponse
  }): Observable<LoadCellTypeResponseDlmBaseResponse> {

    return this.apiLoadCellTypeLoadCellTypePost$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<LoadCellTypeResponseDlmBaseResponse>) => r.body as LoadCellTypeResponseDlmBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiLoadCellTypeLoadCellTypePost$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiLoadCellTypeLoadCellTypePost$Json$Response(params?: {
    body?: LoadCellTypeResponse
  }): Observable<StrictHttpResponse<LoadCellTypeResponseDlmBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, LoadCellTypeService.ApiLoadCellTypeLoadCellTypePostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<LoadCellTypeResponseDlmBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiLoadCellTypeLoadCellTypePost$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiLoadCellTypeLoadCellTypePost$Json(params?: {
    body?: LoadCellTypeResponse
  }): Observable<LoadCellTypeResponseDlmBaseResponse> {

    return this.apiLoadCellTypeLoadCellTypePost$Json$Response(params).pipe(
      map((r: StrictHttpResponse<LoadCellTypeResponseDlmBaseResponse>) => r.body as LoadCellTypeResponseDlmBaseResponse)
    );
  }

  /**
   * Path part for operation apiLoadCellTypeEditLoadCellTypePost
   */
  static readonly ApiLoadCellTypeEditLoadCellTypePostPath = '/api/LoadCellType/edit-loadCellType';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiLoadCellTypeEditLoadCellTypePost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiLoadCellTypeEditLoadCellTypePost$Plain$Response(params?: {
    body?: LoadCellTypeResponse
  }): Observable<StrictHttpResponse<LoadCellTypeResponseDlmBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, LoadCellTypeService.ApiLoadCellTypeEditLoadCellTypePostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<LoadCellTypeResponseDlmBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiLoadCellTypeEditLoadCellTypePost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiLoadCellTypeEditLoadCellTypePost$Plain(params?: {
    body?: LoadCellTypeResponse
  }): Observable<LoadCellTypeResponseDlmBaseResponse> {

    return this.apiLoadCellTypeEditLoadCellTypePost$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<LoadCellTypeResponseDlmBaseResponse>) => r.body as LoadCellTypeResponseDlmBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiLoadCellTypeEditLoadCellTypePost$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiLoadCellTypeEditLoadCellTypePost$Json$Response(params?: {
    body?: LoadCellTypeResponse
  }): Observable<StrictHttpResponse<LoadCellTypeResponseDlmBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, LoadCellTypeService.ApiLoadCellTypeEditLoadCellTypePostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<LoadCellTypeResponseDlmBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiLoadCellTypeEditLoadCellTypePost$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiLoadCellTypeEditLoadCellTypePost$Json(params?: {
    body?: LoadCellTypeResponse
  }): Observable<LoadCellTypeResponseDlmBaseResponse> {

    return this.apiLoadCellTypeEditLoadCellTypePost$Json$Response(params).pipe(
      map((r: StrictHttpResponse<LoadCellTypeResponseDlmBaseResponse>) => r.body as LoadCellTypeResponseDlmBaseResponse)
    );
  }

  /**
   * Path part for operation apiLoadCellTypeDeleteLoadCellTypePost
   */
  static readonly ApiLoadCellTypeDeleteLoadCellTypePostPath = '/api/LoadCellType/delete-loadCellType';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiLoadCellTypeDeleteLoadCellTypePost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiLoadCellTypeDeleteLoadCellTypePost$Plain$Response(params?: {
    body?: LoadCellTypeResponse
  }): Observable<StrictHttpResponse<LoadCellTypeResponseDlmBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, LoadCellTypeService.ApiLoadCellTypeDeleteLoadCellTypePostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<LoadCellTypeResponseDlmBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiLoadCellTypeDeleteLoadCellTypePost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiLoadCellTypeDeleteLoadCellTypePost$Plain(params?: {
    body?: LoadCellTypeResponse
  }): Observable<LoadCellTypeResponseDlmBaseResponse> {

    return this.apiLoadCellTypeDeleteLoadCellTypePost$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<LoadCellTypeResponseDlmBaseResponse>) => r.body as LoadCellTypeResponseDlmBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiLoadCellTypeDeleteLoadCellTypePost$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiLoadCellTypeDeleteLoadCellTypePost$Json$Response(params?: {
    body?: LoadCellTypeResponse
  }): Observable<StrictHttpResponse<LoadCellTypeResponseDlmBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, LoadCellTypeService.ApiLoadCellTypeDeleteLoadCellTypePostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<LoadCellTypeResponseDlmBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiLoadCellTypeDeleteLoadCellTypePost$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiLoadCellTypeDeleteLoadCellTypePost$Json(params?: {
    body?: LoadCellTypeResponse
  }): Observable<LoadCellTypeResponseDlmBaseResponse> {

    return this.apiLoadCellTypeDeleteLoadCellTypePost$Json$Response(params).pipe(
      map((r: StrictHttpResponse<LoadCellTypeResponseDlmBaseResponse>) => r.body as LoadCellTypeResponseDlmBaseResponse)
    );
  }

  /**
   * Path part for operation apiLoadCellTypeRestorePost
   */
  static readonly ApiLoadCellTypeRestorePostPath = '/api/LoadCellType/restore';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiLoadCellTypeRestorePost$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiLoadCellTypeRestorePost$Plain$Response(params?: {
    id?: number;
  }): Observable<StrictHttpResponse<BooleanDlmBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, LoadCellTypeService.ApiLoadCellTypeRestorePostPath, 'post');
    if (params) {
      rb.query('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BooleanDlmBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiLoadCellTypeRestorePost$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiLoadCellTypeRestorePost$Plain(params?: {
    id?: number;
  }): Observable<BooleanDlmBaseResponse> {

    return this.apiLoadCellTypeRestorePost$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<BooleanDlmBaseResponse>) => r.body as BooleanDlmBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiLoadCellTypeRestorePost$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiLoadCellTypeRestorePost$Json$Response(params?: {
    id?: number;
  }): Observable<StrictHttpResponse<BooleanDlmBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, LoadCellTypeService.ApiLoadCellTypeRestorePostPath, 'post');
    if (params) {
      rb.query('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BooleanDlmBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiLoadCellTypeRestorePost$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiLoadCellTypeRestorePost$Json(params?: {
    id?: number;
  }): Observable<BooleanDlmBaseResponse> {

    return this.apiLoadCellTypeRestorePost$Json$Response(params).pipe(
      map((r: StrictHttpResponse<BooleanDlmBaseResponse>) => r.body as BooleanDlmBaseResponse)
    );
  }

}
